import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Like Validators.required, but also rejects whitespace-only strings (e.g. "   ").
 * Returns `{ required: true }` so existing Required error UI keeps working.
 */
export const requiredNonWhitespaceValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;
  if (value == null || value === '') {
    return { required: true };
  }
  if (typeof value === 'string' && value.trim().length === 0) {
    return { required: true };
  }
  return null;
};
